import { render } from "./UpdateRequestTable.vue?vue&type=template&id=4775e680&scoped=true&ts=true"
import script from "./UpdateRequestTable.vue?vue&type=script&lang=ts"
export * from "./UpdateRequestTable.vue?vue&type=script&lang=ts"

import "./UpdateRequestTable.vue?vue&type=style&index=0&id=4775e680&scoped=true&lang=css"

import exportComponent from "C:\\repo\\ono\\ops-front-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4775e680"]])

export default __exports__